import Store from "../../store";
import {auth} from "../../services/Auth";

export default async function guest({ next }) {
  if (Store.getters['auth/isAuthenticated']) {
    return next({ name: 'dashboard' });
  }

  try {
    await auth();

    if (Store.getters['auth/isAuthenticated']) {
      return next({ name: 'dashboard' });
    }
  } catch (e) {
  }

  return next();
}
